import React, { Component } from "react";
import { connect } from "react-redux";
import SideBar from "./components/SideBar";
import { Switch, Route, withRouter } from "react-router-dom";
import TrainingChatBot from "./components/TainingChatBot";
import Chat from "../../chat";
import { compose } from "redux";
import { getKeycloackRefreshToken } from "../../../redux/actions/auth";
import Loader from "../../../components/loader";
import {
  setMessage,
  clearMessages,
  setReadyState,
  setHistoryLimit,
} from "../../../redux/actions/chatActions";
import {
  getUserSkills,
  searchMySKills,
  deleteMySkill,
  getSkillsFromStore,
  getUserHelperSkills,
  getDraftSkills,
  clearDraft,
  deleteDraftSkill,
  getSession,
  deleteV2Agent,
} from "../../../redux/actions/skill";
import { SocketManager } from "../../../ws";
import HelperEdit from "../skillStore/components/HelperEdit";
import MyPublishedSkills from "./components/MyPublishedSkills";
import MyDraftSkills from "./components/MyDraftSkills";
import SearchResults from "./components/SearchResults";
import FlowScreen from "./components/FlowScreen";
import DownloadPdf from "../../../components/downloadPdf";
import AdvanceDataMapper from "./components/FlowScreen/components/FlowDiagram/AdvanceDataMapper";

import ApiInfoModal from "./components/ApiInfoModal";
import CloneSkillModal from "./components/CloneSkillModal";
import MySkillHome from "./components/MySkillHome";

import Support from "./components/Support";
import Session from "../Session";

import ExtensionManual from "./components/Support/Article/extensionManual";
import Guidelines from "./components/Support/Article/guidelines";
import Requirements from "./components/Support/Article/requirements";

import Unauthorised from "./components/unauthorised";
import SkillOnboard from "./components/SkillOnboard";

import Template from "./components/template";

import PublishedSearchResults from "./components/PublishedSearchResults";
import Collections from "./components/Collections";
import Transcribe from "./components/Collections/transcribe";
import CollectionWorkspace from "./components/Collections/Workspace/index";
import SkillSets from "./components/SkillSets";
import Analytics from "../Analytics";
import ProcessDiscovery from "./components/ProcessDiscovery/ProcessDiscovery";
import ViewChartProcessDiscovery from "./components/ProcessDiscovery/viewChart";
import CompareFlow from "./components/ProcessDiscovery/CompareFlow";
import AggregateFlow from "./components/ProcessDiscovery/AggregateFlow";
import CreateV2skills from "./components/createV2Skill/createV2skills";
import ViewV2skill from "./components/createV2Skill/viewV2skills";
import EditSkillModal from "./components/EditSkillModal";
class MySkills extends Component {
  constructor(props) {
    super(props);
    this.state = {
      enableChat: false,
      activeSkillName: null,
      loader: false,
      page: 1,
      showHistory: false,
    };
  }

  componentDidMount() {
    // this.props.getUserSkills();
    // this.props.getUserHelperSkills();
    // this.props.getSkillsFromStore();
    // this.props.getDraftSkills();
    // this.triggerSkill();
    this.props.getSession();
  }

  triggerSkill = () => {
    if (this.props.location.state) {
      const { skill } = this.props.location.state;
      this.chatSkill(skill);
    }
  };

  chatSkill = async (skill) => {
    if (skill.SKILL_NAME !== this.state.activeSkillName) {
      this.props.setHistoryLimit({ lt: 1, gt: 0, limit: 20 });
      let uuid = `${this.props.userReducer.user.sub}-${skill.SKILL_NAME.replace(
        / /g,
        "_"
      )}`;
      // window.chatSocket.switchConnection(uuid);
      this.props.clearMessages();
      this.props.setReadyState(false);
      this.setState({
        showHistory: true,
        enableChat: true,
        activeSkillName: skill.SKILL_NAME,
        loader: false,
      });
    } else {
      let _message = { text: skill.SKILL_NAME };
      _message = window.chatSocket.finalPayload(
        _message,
        false,
        await getKeycloackRefreshToken(),
        "",
        true
      );
      if (this.props.chatReducer.ready) {
        this.setState({ showHistory: false });
        this.props.setMessage(_message);
        window.chatSocket.conn.send(_message);
      }
    }
  };

  componentWillUnmount(prevState) {
    let uuid = this.props?.userReducer?.user?.sub;
    // Check Chat socket connection switching
    if (uuid) {
      // window.chatSocket.switchConnection(uuid);
    }
  }

  startOver = async () => {
    this.setState({ enableChat: true });
    let _message = { text: this.state.activeSkillName, start_over: true };
    _message = window.chatSocket.finalPayload(
      _message,
      false,
      await getKeycloackRefreshToken(),
      "",
      true
    );
    if (this.props.chatReducer.ready) {
      this.props.setMessage(_message);
      window.chatSocket.conn.send(_message);
    }
  };

  deleteDraftSkill = async (e, id) => {
    let skillId = this.props.skillReducer.helper
      ? this.props.skillReducer.helper.id
      : "";

    let template = this.props?.skillReducer?.helper?.TEMPLATE;
    if (skillId !== "") {
      const deleteDraft = await this.props.deleteDraftSkill(skillId, template);
      if (template === "GenAi Automation") {
        let agentId = this.props.skillReducer?.helper?.v2AgentId;

        await this.props.deleteV2Agent(agentId);
      }
      if (deleteDraft) {
        this.props.clearDraft();

        this.props.history.push(window.location.pathname);
      }
    }
  };

  render() {
    let { enableChat, skillName, loader, showHistory } = this.state;
    return (
      <div className="align-row">
        <ApiInfoModal />
        <CloneSkillModal />
        <EditSkillModal />
        {/* <SideBar {...this.props} chatSkill={this.chatSkill} /> */}

        {loader ? (
          <>
            <Loader
              styles={{ width: "80px", margin: "auto" }}
              root={{ display: "flex" }}
            />
          </>
        ) : enableChat ? (
          <Chat
            skillName={skillName}
            startOver={this.startOver}
            showHistory={showHistory}
          />
        ) : (
          <Switch>
            <Route
              path="/dashboard/skills/published"
              render={() => <MyPublishedSkills chatSkill={this.chatSkill} />}
            />
            <Route
              path="/dashboard/skills/draft"
              render={() => <MyDraftSkills />}
            />
            <Route
              path="/dashboard/skills/search/:id"
              render={() => <SearchResults />}
            />
            <Route
              path="/dashboard/skills/searchSkill"
              render={() => <PublishedSearchResults />}
            />
            <Route
              path="/dashboard/skills/trainSkill/:id"
              render={() => <TrainingChatBot />}
            />

            <Route
              path="/dashboard/skills/viewSkill/:id"
              render={() => {
                return <FlowScreen />;
              }}
            />
            <Route
              path="/dashboard/skills/onboard/:id"
              render={() => {
                return <SkillOnboard />;
              }}
            />

            <Route
              path="/dashboard/skills/unauthorised"
              render={() => {
                return <Unauthorised />;
              }}
            />
            <Route
              path="/dashboard/skills/viewChart/:id"
              render={() => {
                return <ViewChartProcessDiscovery />;
              }}
            />

            {/* <Route
              path="/dashboard/skills/exportSkill/:id"
              render={() => <DownloadPdf />}
            /> */}

            <Route
              path="/dashboard/skills/support"
              render={() => <Support />}
            />

            <Route
              path="/dashboard/skills/extensionManual"
              render={() => <ExtensionManual />}
            />
            <Route
              path="/dashboard/skills/guidelines"
              render={() => <Guidelines />}
            />
            <Route
              path="/dashboard/skills/requirements"
              render={() => <Requirements />}
            />
            <Route
              path="/dashboard/skills/template"
              render={() => <Template />}
            />

            <Route
              path="/dashboard/skills/mapYourData"
              render={() => <AdvanceDataMapper />}
            />

            {/* <Route
              path="/dashboard/skills/home"
              render={() => <MySkillHome />}
            /> */}
            <Route
              path="/dashboard/skills/collections"
              render={() => <Collections />}
            />
            {/* <Route
              path="/dashboard/skills/transcribe"
              render={() => <Transcribe />}
            /> */}
            {/* <Route
              path="/dashboard/skills/collectionWorkspace"
              render={() => <CollectionWorkspace />}
            /> */}
            <Route
              path="/dashboard/skills/skillSets"
              render={() => <SkillSets />}
            />
            <Route
              path="/dashboard/skills/analytics/:id"
              render={() => <Analytics />}
            />
            <Route
              path="/dashboard/skills/user/session/:id"
              render={() => <Session />}
            />
            <Route
              path="/dashboard/skills/process-discovery"
              render={() => <ProcessDiscovery />}
            />
            <Route
              path="/dashboard/skills/compare-process"
              render={() => <CompareFlow />}
            />
            <Route
              path="/dashboard/skills/aggregate-process"
              render={() => <AggregateFlow />}
            />
            <Route
              path="/dashboard/skills/createAutomationV2/:id"
              render={() => <CreateV2skills />}
            />
            <Route
              path="/dashboard/skills/viewAutomationV2"
              render={() => <ViewV2skill />}
            />
          </Switch>
        )}
        {/* Draft Delete Modal */}
        <div className="modal fade qa-modal1" id="myDeleteModal" role="dialog">
          <div className="modal-dialog modal-sm">
            <div className="modal-content share-modal">
              <button type="button" className="close" data-dismiss="modal">
                &times;
              </button>
              <div className="modal-body">
                <h3 className="qa-modal-title">Delete</h3>
                <div>
                  <h5>Please confirm delete action.</h5>
                </div>

                <div className="frm-btns fb-right">
                  <button className="btn-outline" data-dismiss="modal">
                    Cancel
                  </button>
                  <button
                    className="btn-primary"
                    data-dismiss="modal"
                    onClick={() => {
                      this.deleteDraftSkill();
                    }}
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  skillReducer: state.skillReducer,
  userReducer: state.userReducer,
  // chatReducer: state.chatReducer,
  appReducer: state.appReducer,
  organizationReducer: state.organizationReducer,
});
export default compose(
  withRouter,
  connect(mapStateToProps, {
    getUserSkills,
    searchMySKills,
    deleteMySkill,
    getSkillsFromStore,
    getUserHelperSkills,
    setMessage,
    getDraftSkills,
    setMessage,
    clearMessages,
    setReadyState,
    setHistoryLimit,
    deleteDraftSkill,
    clearDraft,
    getSession,
    deleteV2Agent,
  })
)(MySkills);
